import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isRealDate } from '../../utils/warehouseDates'
import { maxToFor, minFromFor } from './coveragePeriod'
import { textButton } from './coverageStyles'
import { PERIOD_I18N } from './i18nKeys'

const ERROR_ID = 'proof-video-coverage-period-error'

const dateInput = 'rounded border border-gray-300 bg-white px-2 py-1 text-sm'

// Rendered with a key of the period it starts from, so a new period starts a fresh draft.
export const CustomRangeForm = ({ period, today, onApply }) => {
  const { t } = useTranslation()
  const [draft, setDraft] = useState({ from: period.from, to: period.to })
  const [error, setError] = useState(null)

  const fromMax = draft.to || today
  const fromMin = isRealDate(draft.to) ? minFromFor(draft.to) : undefined
  const toMax = isRealDate(draft.from) && maxToFor(draft.from) < today ? maxToFor(draft.from) : today

  const edit = field => event => {
    setDraft({ ...draft, [field]: event.target.value })
    setError(null)
  }

  const submit = event => {
    event.preventDefault()
    if (!isRealDate(draft.from) || !isRealDate(draft.to)) return setError('malformed')
    onApply(draft)
  }

  const invalid = error ? { 'aria-invalid': 'true', 'aria-describedby': ERROR_ID } : {}

  return (
    <form noValidate onSubmit={submit} className="flex flex-wrap items-end gap-3">
      <label className="flex flex-col gap-1 text-sm text-gray-700">
        {t(`${PERIOD_I18N}.from`)}
        <input type="date" className={dateInput} value={draft.from} min={fromMin} max={fromMax} onChange={edit('from')} {...invalid} />
      </label>
      <label className="flex flex-col gap-1 text-sm text-gray-700">
        {t(`${PERIOD_I18N}.to`)}
        <input type="date" className={dateInput} value={draft.to} min={draft.from || undefined} max={toMax} onChange={edit('to')} {...invalid} />
      </label>
      <button type="submit" className={textButton}>
        {t(`${PERIOD_I18N}.apply`)}
      </button>
      {error && (
        <p id={ERROR_ID} role="alert" className="w-full text-sm text-red-700">
          {t(`${PERIOD_I18N}.errors.${error}`)}
        </p>
      )}
    </form>
  )
}
